import { createSelector } from 'reselect';
import { getPrescriptionGlasses } from '../selectors.internal.js';

const getPrescription = createSelector(getPrescriptionGlasses, (pg)=>pg.prescription
);

export { getPrescription };
//# sourceMappingURL=selectors.internal.js.map
